(ns common.feedback-ratings
  (:require [common.util :as cu]))

(defonce options [{:key   :feedback-rating/very-dissatisfied
                   :label "Very dissatisfied"
                   :value 0.2}
                  {:key   :feedback-rating/dissatisfied
                   :label "Dissatisfied"
                   :value 0.4}
                  {:key   :feedback-rating/neutral
                   :label "Neutral"
                   :value 0.6}
                  {:key   :feedback-rating/satisfied
                   :label "Satisfied"
                   :value 0.8}
                  {:key   :feedback-rating/very-satisfied
                   :label "Very satisfied"
                   :value 1.0}])

(def get-key (partial cu/get-key options))

(def get-label (partial cu/get-label options))
